import { RankedTester, and, rankWith, optionIs, schemaTypeIs } from "@jsonforms/core";

export const EventsSelectMultipleTester: RankedTester = rankWith(
  3,
  and(schemaTypeIs("array"), optionIs("EventsSelect", true))
);

export default EventsSelectMultipleTester;
